module.exports = __webpack_public_path__ + "fa7d57fe2156fbbc2a4b7e67b3755a11.MP3";